import React from 'react';
import * as P from 'prop-types';
import { Collapse, makeStyles } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  alert: {
    marginBottom: '15px',
  },
}));
export default function InlineAlertCollapse({
  show, message, severity, button,
}) {
  const classes = useStyles();
  const collapseRef = React.useRef();
  const id = React.useMemo(() => `alert-${Math.floor(Math.random() * 100)}`);

  return (
    <Collapse className={classes.alert} id={id} in={show} ref={collapseRef}>
      <Alert severity={severity || undefined} action={button}>{message ?? ''}</Alert>
    </Collapse>
  );
}

InlineAlertCollapse.propTypes = {
  show: P.bool.isRequired,
  message: P.string,
  severity: P.string,
  button: P.node,
};

InlineAlertCollapse.defaultProps = {
  button: null,
  message: null,
  severity: null,
};
